module.exports = __webpack_public_path__ + "static/media/order-of-man.3ed65006.png";